<template>
  <div class="order-search">
    <div class="top">
      <div :class="{active: activeIndex ===1}" @click="isActive(1)">订单查询</div>
      <div :class="{active: activeIndex ===2}" @click="isActive(2)">查询列表</div>
    </div>
    <div class="content" v-if="activeIndex ===1">
      <div class="search">
        <el-input
          v-model="searchOrderCode"
          class="white w410"
          placeholder="请输入订单号"
          clearable
          @keyup.enter.native="search"
        ></el-input>
        <el-button class="btn-blue" @click="search" >搜索</el-button>
      </div>
      <div class="container">
        <div v-if="isNothing" class="title-row">
          <div class="title">订单信息</div>
          <el-button class="btn-blue intercept-btn" v-if="hasInterceptFlag !== 1" @click="intercept">发起拦截</el-button>
          <el-button class="btn-text" type="text" v-else>已发起</el-button>
        </div>
        <div v-if="isNothing" class="main">
          <div class="row">
            <span class="subTitle">下单时间</span>
            <span>{{ orderCreateTime }}</span>
          </div>
          <div class="row">
            <span class="subTitle">订单号</span>
            <span>{{ systemOrderNo }}</span>
          </div>
          <div class="row">
            <span class="subTitle">运单号</span>
            <span>{{ expressNo }}</span>
          </div>
          <div class="row">
            <span class="subTitle">承运商</span>
            <span>{{ carrier }}</span>
          </div>
          <div class="row">
            <span class="subTitle">外部单号</span>
            <span>{{ externalOrderNo }}</span>
          </div>
          <div class="row">
            <span class="subTitle">商品信息</span>
            <span>{{ skuInfo }}</span>
          </div>
          <div class="row">
            <span class="subTitle">商品数量</span>
            <span>{{ skuQuantity }}</span>
          </div>
        </div>
        <div class="nothing" v-if="!isNothing">
          <img src="../../../assets/images/customer/nothing.png">
        </div>
      </div>
    </div>
    <div v-if="activeIndex ===2">
      <div class="search-container">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          label-width="80px"
          class="demo-ruleForm"
          hide-required-asterisk
        >
          <div class="search-row">
            <el-form-item label="下单时间：" prop="date">
              <el-date-picker
                v-model="ruleForm.date"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="——"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="订单号：" prop="orderCode">
              <el-input
                class="gray white"
                v-model="ruleForm.orderCode"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="状态：" prop="status">
              <el-select v-model="ruleForm.status" class="gray white" placeholder="请选择状态" clearable>
                <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <div class="foot">
              <el-button class="btn-blue" @click="searchData">搜索</el-button>
              <el-button @click="clear('ruleForm')">清空</el-button>
            </div>
          </div>
        </el-form>
      </div>
      <div class="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            v-for="(item, index) in tableTitleList"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            show-overflow-tooltip
            :min-width="item.width"
          ></el-table-column>
          <el-table-column
            label="操作"
            width="120"
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.status === 2"
                class="btn-text"
                type="text"
                @click="voucherPreparation(scope.row.id)"
              >制单</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <pagination-tpl
            :total="total"
            :currentPage="currentPage"
            :pageSize="pageSize"
            @queryChange="queryChange"
          ></pagination-tpl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationTpl from "components/base/PaginationTpl";
import { formaTimeToMinute } from "common/js/util";
const STATUS = {1:'待拦截', 2:'已拦截',3:'已制单',4:'已入库'}
import Customer from "models/customer";
export default {
  components: {
    PaginationTpl,
  },

  data() {
    return {
      activeIndex: 1,
      isNothing: false,
      searchOrderCode: '',
      orderCreateTime: "",
      systemOrderNo: "",
      expressNo: "",
      carrier: "",
      externalOrderNo: "",
      skuInfo: "",
      skuQuantity: "",
      hasInterceptFlag: 0,
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitleList: [
        {label: '下单时间', prop: 'orderCreateTime', width: '150'},
        {label: '订单号', prop: 'systemOrderNo', width: '120'},
        {label: '运单号', prop: 'expressNo', width: '120'},
        {label: '承运商', prop: 'carrier', width: '120'},
        {label: '外部单号', prop: 'externalOrderNo', width: '200'},
        {label: '商品信息', prop: 'skuInfo', width: '240'},
        {label: '商品数量', prop: 'skuQuantity', width: '100'},
        {label: '拦截时间', prop: 'interceptTime', width: '150'},
        {label: '状态', prop: 'statusVal', width: '120'},
      ],
      statusList: [
        {id:1, name: '待拦截'},
        {id:2, name: '已拦截'},
        {id:3, name: '已制单'},
        {id:4, name: '已入库'},
      ],
      ruleForm: {
        orderCode: '',
        date: '',
        status: ''
      },
    }
  },

  created() {
    this.initOrderSearchList()
  },

  methods: {
    isActive(v) {
      this.activeIndex = v
    },
    search() {
      let code = this.searchOrderCode
      Customer.getInterceptOrderCodeSearch(code).then(res => {
        if (res.success) {
          if (res.result) {
            this.orderCreateTime = formaTimeToMinute(res.result.createdTime)
            this.systemOrderNo = res.result.systemOrderNo
            this.expressNo = res.result.expressNo
            this.carrier = res.result.carrier
            this.externalOrderNo = res.result.externalOrderNo
            this.skuInfo = res.result.skuInfo
            this.skuQuantity = res.result.skuQuantity
            this.hasInterceptFlag = res.result.hasInterceptFlag
            this.isNothing = true
          } else {
            this.isNothing = false
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    /* 发起拦截 */
    intercept() {
      this.$confirm("确认对此订单发起拦截？", "发起拦截", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "messageBox",
        confirmButtonClass: "btn-blue",
        cancelButtonClass: "btn-white",
      })
        .then(() => {
          let data = {
            systemOrderNo: this.systemOrderNo
          }
          Customer.postIntercept(data).then(res => {
            if (res.success) {
              this.$message({
                type: "success",
                message: "拦截成功!"
              });
              this.search()
              this.initOrderSearchList();
            } else {
              this.$message.error(res.message)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initOrderSearchList();
    },
    initOrderSearchList() {
      let pageNo = this.currentPage
      let code = this.ruleForm.orderCode
      let beginDate = this.ruleForm.date[0]?this.ruleForm.date[0]:''
      let endDate = this.ruleForm.date[1]?this.ruleForm.date[1]:''
      let status = this.ruleForm.status
      Customer.getInterceptOrderCodeList(pageNo,code,beginDate,endDate,status).then(res => {
        if (res.success) {
          let arr = []
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.orderCreateTime = formaTimeToMinute(i.orderCreateTime)
            if (i.interceptTime) {
              obj.interceptTime = formaTimeToMinute(i.interceptTime)
            } else {
              obj.interceptTime = '/'
            }
            obj.skuInfo = i.skuInfo
            obj.skuQuantity = i.skuQuantity
            obj.systemOrderNo = i.systemOrderNo
            obj.expressNo = i.expressNo
            obj.externalOrderNo = i.externalOrderNo
            obj.carrier = i.carrier
            obj.status = i.status
            obj.statusVal = STATUS[i.status]
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          if (res.code === 1004) {
            return
          }
          this.$message.error(res.message)
        }
      })
    },
    clear(formName) {
      this.$refs[formName].resetFields();
    },
    searchData() {
      this.currentPage = 1;
      this.initOrderSearchList();
    },
    voucherPreparation(id) {
      this.$confirm("确认对此订单制单？", "制单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "messageBox",
        confirmButtonClass: "btn-blue",
        cancelButtonClass: "btn-white",
      })
        .then(() => {
          let data = {
            id
          }
          Customer.postVoucherPreparation(data).then(res => {
            if (res.success) {
              this.$message({
                type: "success",
                message: "制单成功!"
              });
              this.initOrderSearchList();
            } else {
              this.$message.error(res.message)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    }
  }
}
</script>

<style lang='scss'>
.order-search {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0px 20px 20px 20px;
  .top {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
    div {
      width: 100px;
      height: 36px;
      line-height: 36px;
      font-size: 16px;
      font-weight: 400;
      color: #999999;
      cursor: pointer;
      text-align: center;
    }
    div:nth-child(2) {
      margin-left: 20px;
    }
    .active {
      background: #FFFFFF;
      box-shadow: 0px 4px 8px 0px rgba(61, 116, 242, 0.1);
      border-radius: 8px;
    }
  }
  .content {
    flex: 1;
    background: #fff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 40px;
    .container {
      width: 800px;
      height: 392px;
      border: 1px solid #EEEEEE;
      margin-top: 40px;
      padding: 16px;
      .title-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 16px;
        .title {
          font-size: 16px;
          font-weight: 400;
          color: #333333;
        }
        .intercept-btn {
          text-align: center;
          border: 1px solid #2E68EA;
          border-radius: 4px;
          font-size: 14px;
          font-weight: 400;
          color: #2E68EA;
          background: #fff;
        }
      }
      .main {
        background: #F8F9FA;
        border-radius: 6px;
        .row {
          min-height: 44px;
          display: flex;
          align-items: center;
          font-size: 12px;
          font-weight: 400;
          color: #333333;
          border-bottom: 1px solid #eee;
          .subTitle {
            width: 150px;
            padding-left: 20px;
            color: #999999;
          }
          span:nth-last-child(1) {
            flex: 1;
            word-break:break-all;
            line-height: 16px;
          }
        }
        .row:nth-last-child(1) {
          border-bottom: none;
        }
      }
    }
  }
  .w410 {
    width: 410px;
    margin-right: 20px;
  }
  .nothing {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 160px;
      height: 128px;
    }
  }
  .search-container {
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 16px;
    .search-row {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    .el-select {
      width: 200px;
      margin-right: 16px;
    }
    .el-input {
      width: 200px;
    }
    .foot {
      margin-bottom: 16px;
    }
  }
  .table {
    min-height: 500px;
    padding: 16px;
    background: #fff;
    border-radius: 4px;
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
